import { Grid, Typography, withStyles } from '@material-ui/core'
import { getStyles } from 'isotope-client'
import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { compose } from 'redux'
import Button from '../../../../../../../components/Button'
import classnames from 'classnames'
import { colors } from '../../../../../../../utils/constants'
import { BIO_AGGRESSOR_TYPE } from '../../tool/suiviParBloc.constants'

/**
 * Styles
 */
const styles = () => getStyles({
	container: {
		gap: 15
	},
	bioAggressor: {
		minWidth: 100,
		width: 100,
		height: 100,
		gap: 6,
		borderRadius: 15,
		borderWidth: 2,
		borderStyle: 'solid',
		borderColor: 'transparent',
		'&:hover': {
			color: 'white',
			backgroundColor: colors.primary
		},
		'&:active': {
			color: 'white',
			backgroundColor: colors.primary
		}
	},
	selectedBioAggressor: {
		color: '#fff',
		textColor: '#fff',
		borderColor: 'transparent',
		backgroundColor: colors.primary
	},
	inactiveBioAggressor: {
		color: colors.primary,
		textColor: '#000',
		borderColor: colors.lightPrimary,
		backgroundColor: '#fff'
	},
	bioAggressorLabelContent: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
	},
	bioAggressorLabel: {
		fontSize: 15,
		lineHeight: '18px',
		fontWeight: '400'
	},
	selectedBioAggressorLabel: {
		color: '#fff'
	},
	inactiveBioAggressorLabel: {
		color: '#000'
	},
	errorText: {
		color: colors.error,
		fontSize: 11
	},
	link: {
		'&.MuiTypography-root': {
			color: colors.link,
			textDecoration: 'underline',
			cursor: 'pointer',
			textAlign: 'center',
			marginTop: 10
		}
	},
})

/**
 * BioAggressorsInput
 * @param onChange
 * @param error
 * @param bioAggressors
 * @returns {JSX.Element}
 * @constructor
 */
const BioAggressorsInput = ({
	input: { onChange, value },
	meta: { error, submitFailed },
	bioAggressors,
	classes
}) => {
	const renderBioAggressors = (type) => (
		<Grid container justify="center" className={classes.container}>
			{
				bioAggressors.filter(bA => bA.type === type.code)
					.map((bA) => {
						const isSelected = value.find(sBa => sBa === bA.id)
						const Icon = type.icon
						return (
							<Button
								key={`${bA.id}`}
								type="primary"
								keepCase
								withBorder={false}
								className={classnames(classes.bioAggressor, isSelected ? classes.selectedBioAggressor : classes.inactiveBioAggressor)}
								onClick={() => {
									if (value.find(sBa => sBa === bA.id)) {
										onChange(value.filter(sBa => sBa !== bA.id))
									} else {
										onChange([...value, bA.id])
									}
								}}
							>
								<div className={classes.bioAggressorLabelContent}>
									<Icon style={{ height: 40, width: 40 }} />
									{bA.label}
								</div>
							</Button>
						)
					})
			}
		</Grid>
	)

	return (
		<Grid container className={classes.container}>
			{renderBioAggressors(BIO_AGGRESSOR_TYPE.SOIL_BORNE)}
			{renderBioAggressors(BIO_AGGRESSOR_TYPE.MAMMAL)}
			{(error && submitFailed) && <Typography className={classes.errorText}><FormattedMessage id={error.id} /></Typography>}
		</Grid>
	)
}

BioAggressorsInput.propType = {
	input: PropTypes.object,
	meta: PropTypes.object,
	bioAggressors: PropTypes.array,
	classes: PropTypes.object
}

export default compose(
	withStyles(styles)
)
(BioAggressorsInput)
